module.exports = __webpack_public_path__ + "static/media/icon_diversification.6322ab36.svg";